import { useState, useEffect } from "react";
import { getAxiosInstance } from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import { Button, FormControl, FormLabel, Input } from "@chakra-ui/react";
import Modal from "../Modal";
import DeleteModal from "../DeleteModal";
import { useUserContext } from "../../utils/userContext";
import { checkIfAdmin } from "../../utils/security";

interface NewRoleModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: any
}

const EditModalProvider = (props: NewRoleModalProps) => {
  const [provider, setProvider] = useState<any>({});
  const { t } = useTranslation("translations");
  const { permission, user } = useUserContext();
  const [deleteProvider, setDeleteProvider] = useState<boolean>(false);


  const setUpProviderObject = (value: string, name: string) => {
    setProvider({ ...provider, [name]: value });
  }

  const EditProvider = async () => {
    try {
      await getAxiosInstance().put('/providers', { id: props.data.id, ...provider, no: undefined });
      toast.success(t("PROVIDER_EDITED_SUCCESSFULLY"), { position: toast.POSITION.BOTTOM_RIGHT });
      setProvider({});
      props.onClose();
    } catch (error) {
      toast.error(t("SOMETHING_WENT_WRONG"), { position: toast.POSITION.BOTTOM_RIGHT });
    }
  }

  const deleteProviderF = async () => {
    try {
      await getAxiosInstance().delete(`/providers/${props.data.id}`);
      toast.success(t("PROVIDER_DELETED_SUCCESSFULLY"), { position: toast.POSITION.BOTTOM_RIGHT });
      setProvider({});
      props.onClose();
    } catch (error) {
      toast.error(t("SOMETHING_WENT_WRONG"), { position: toast.POSITION.BOTTOM_RIGHT });
    }
  }

  const deleteEntity = <Button className="mr-2" name={"Delete"} colorScheme={"red"} variant={"outline"}
    onClick={() => setDeleteProvider(true)}>{t("DELETE")} </Button>;

  useEffect(() => {
    setProvider(props.data)
  }, [props.data])

  return (
    <>
      <Modal
        header={t("EDIT_PROVIDER")}
        isOpen={props.isOpen}
        onClose={props.onClose}
        secondaryActionName={t("Save")}
        secondaryActionEnabled={ checkIfAdmin(user) || permission.findIndex((x) => x === "EditProviders") !== -1}
        secondaryAction={() => EditProvider()}
        additionalBtn={(checkIfAdmin(user) || permission.findIndex((x) => x === "DeleteProviders") !== -1) ? deleteEntity : <></>}
      >
        <div className="space-y-2">
          <FormControl>
            <FormLabel>{t("Name")}</FormLabel>
            <Input value={provider.name} name='name' onChange={(e) => {
              setUpProviderObject(e.target.value, e.target.name)
            }} placeholder='ex: John Doe' />
          </FormControl>
          <FormControl mt={2}>
            <FormLabel>C.U.I</FormLabel>
            <Input value={provider.cui} name="cui" onChange={(e) => {
              setUpProviderObject(e.target.value, e.target.name)
            }} placeholder='ex: RO123456789C' />
          </FormControl>
          <FormControl mt={2}>
            <FormLabel> {t("Address")}</FormLabel>
            <Input value={provider.address} name="address" onChange={(e) => {
              setUpProviderObject(e.target.value, e.target.name)
            }} placeholder='ex: Str Mihai Eminescu nr.19 ap.31' />
          </FormControl>
          <FormControl mt={2}>
            <FormLabel> {t("Phone Number")}</FormLabel>
            <Input value={provider.phoneNumber} name="phoneNumber" onChange={(e) => {
              setUpProviderObject(e.target.value, e.target.name)
            }} placeholder='ex: +40745555555' />
          </FormControl>
          <FormControl mt={2}>
            <FormLabel> {t("Email")}</FormLabel>
            <Input value={provider.email} name="email" onChange={(e) => {
              setUpProviderObject(e.target.value, e.target.name)
            }} placeholder='ex: example@gmail.con' size='md' />
          </FormControl>
          <FormControl mt={2}>
            <FormLabel> {t("Country")}</FormLabel>
            <Input value={provider.country} name="country" onChange={(e) => {
              setUpProviderObject(e.target.value, e.target.name)
            }} placeholder='ROMANIA' />
          </FormControl>

        </div>
        <DeleteModal
          isOpen={deleteProvider}
          delete={() => {
            deleteProviderF()
          }}
          onClose={() => setDeleteProvider(false)}
        />
      </Modal>

    </>
  )
}


export default EditModalProvider;